import axios from 'axios';
import React,  { useState, useEffect }  from 'react'
import { Helmet } from 'react-helmet';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Card, Main } from '../../Components';
import { ReactComponent as Logo } from './../../assets/logo/logo.svg'

export function EmailValidation() {

	
	const { confirmation_token } = useParams()
	const navigate = useNavigate()
	
	const [isLoadingSubmit, setIsLoadingSubmit] = useState(false)
	const [response, setResponse] = useState({
		message : "",
		status : "danger"
	})

	useEffect(() => {

		async function fetch() {
			//console.log('useeffect ...');
			try{
				const response = await emailVlidationProcess();
                setTimeout(() => {
                    navigate(`/pages`)
                    
                }, 2000);

			}catch(error){

			}
			
		}
		fetch()
	}, [])
	
	
	/**
	 * 
	 * @param {*} e 
	 * @returns 
	 */
	const onSubmit = async (e) => {
		e.preventDefault();

		try{
			const response = await emailVlidationProcess();
            setTimeout(() => {
                navigate(`/pages`)
                
            }, 2000);

		}catch(error){

		}

	}

	const emailVlidationProcess = () => {
		return new Promise( async (resolve, reject) => { 
			
			setIsLoadingSubmit(true)
			 
			await axios.post(`${process.env.REACT_APP_API_URL}/users/confirm-email`, {
				token : confirmation_token
			} , {} )
			.then( res => res.data )
			.then( data => {

				setIsLoadingSubmit(false)

				toast.success('Your email has been successfully validated')  
				setResponse({
					message : 'Your email has been successfully validated',
					status : 'success'
				});
	
				resolve(data.data) 
	
			})
			.catch(error => {

				let __error = "Something went wrong. thank you try later.";
				if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
					navigate('/logout')
				}
				setIsLoadingSubmit(false)
				if (error.response) {
					if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
					
							
					}
					__error = ((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
				} else {
					// Something happened in setting up the request that triggered an Error
					if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
						__error = "Something went wrong. thank you try later.";
					}
				}

				// toast.error(__error)  
				setResponse({
					message : __error,
					status : 'danger'
				});
				reject(__error)
			})
			 


		})
	}


	return (
		<>
			<Helmet>
				<title>Email validation - {process.env.REACT_APP_APP_NAME}</title>
			</Helmet>
			<Main size={`full`} withNav={false} positionY="top"  >
				<div className="layout-login-form">
					<div className="logo-wrapper">
						<Logo />
					</div> 
					<Card shadow="md" target="login">
						<form >
							<div className='title'>Email validation</div>
							{
								isLoadingSubmit === true 
								? 'Email validation in progress...'
								: (
									response.message !==''
									? <p className={`alert alert-${response.status} text-${response.status}`}>{response.message}</p> 
									: <>
										<div className="validation-wrapper">
											<Button onClick={onSubmit}>
												<span>Validate your email</span>
											</Button>
										</div>
									</>
								)	
							}
						</form>
					</Card>
				</div>
			</Main>
		</>
	)
}
